import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const socialIconStyle = {
    background: '#fff',
    borderRadius: '50%',
    width: 36,
    height: 36,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background 0.2s',
};

const menuLinkStyle = {
    color: 'rgba(255,255,255,0.55)',
    textDecoration: 'none',
    transition: 'color 0.2s',
    display: 'block',
    fontFamily: "'Roboto', sans-serif",
    fontWeight: 300,
};

const menuItems = [
    { key: 'footer.menu.aboutUs', path: '/chi-siamo' },
    { key: 'footer.menu.projects', path: '/progetti' },
    { key: 'footer.menu.projectFinance', path: '/finanza-di-progetto' },
    { key: 'footer.menu.workWithUs', path: '/lavora-con-noi' },
    { key: 'footer.menu.contacts', path: '/contatti' },
];

export const Footer = () => {
    const { t } = useTranslation();
    const redGradient = "linear-gradient(90deg, #99191b 0%, #e3764c 100%)";

    const isMobile = window.innerWidth <= 768;

    return (
        <footer
            style={{
                background: redGradient,
                color: '#fff',
                width: '100%',
                padding: isMobile ? '32px 6% 40px' : '55px 8% 50px',
            }}
        >
            {/* TOP ROW: info left + menu right */}
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    gap: isMobile ? 20 : 32,
                }}
            >
                {/* LEFT: nome + dati */}
                <div style={{ flex: isMobile ? '1 1 100%' : '1 1 300px' }}>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 0 }}>
                        <span style={{
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 700,
                            fontSize: isMobile ? 26 : 34,
                            letterSpacing: '-0.5px',
                        }}>
                            ESI.PRO
                        </span>
                        <span style={{
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 300,
                            fontSize: isMobile ? 14 : 18,
                            marginLeft: 4,
                        }}>
                            S.r.l.
                        </span>
                    </div>
                    <div style={{
                        marginTop: -2,
                        fontSize: isMobile ? 13 : 14,
                        fontFamily: "'Roboto', sans-serif",
                        fontWeight: 300,
                        lineHeight: 1.5,
                        opacity: 0.85,
                    }}>
                        {t('footer.vatNumber')}<br />
                        {t('footer.addressStreet')}<br />
                        {t('footer.addressCity')}
                    </div>
                </div>

                {/* RIGHT: menu links */}
                <div style={{
                    flex: '0 0 auto',
                    textAlign: isMobile ? 'left' : 'right',
                    ...(isMobile ? { display: 'flex', flexWrap: 'wrap', gap: '0 20px' } : {}),
                }}>
                    <nav>
                        <ul style={{
                            listStyle: 'none',
                            margin: 0,
                            padding: 0,
                            fontSize: isMobile ? 13 : 14,
                            lineHeight: 1.8,
                            ...(isMobile ? { display: 'flex', flexWrap: 'wrap', gap: '0 16px' } : {}),
                        }}>
                            {menuItems.map((item) => (
                                <li key={item.path}>
                                    <Link
                                        to={item.path}
                                        style={menuLinkStyle}
                                        onMouseEnter={(e) => e.currentTarget.style.color = '#fff'}
                                        onMouseLeave={(e) => e.currentTarget.style.color = 'rgba(255,255,255,0.55)'}
                                    >
                                        {t(item.key)}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>
            </div>

            {/* DIVIDER */}
            <div
                style={{
                    borderTop: '1px solid rgba(255,255,255,0.4)',
                    margin: isMobile ? '16px 0 14px' : '24px 0 20px',
                }}
            />

            {/* BOTTOM ROW: copyright left + social right */}
            <div
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: isMobile ? 12 : 16,
                }}
            >
                <span style={{
                    fontSize: isMobile ? 11 : 13,
                    fontFamily: "'Roboto', sans-serif",
                    fontWeight: 300,
                    opacity: 0.8,
                }}>
                    {t('footer.copyright')}
                </span>

                <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                    {/* LinkedIn */}
                    <a href="https://www.linkedin.com/company/esiprosrl/posts/?feedView=all" target="_blank" rel="noopener noreferrer"
                       style={{ ...socialIconStyle, width: isMobile ? 30 : 36, height: isMobile ? 30 : 36 }}>
                        <svg viewBox="0 0 24 24" width={isMobile ? 14 : 18} height={isMobile ? 14 : 18} fill="#99191b">
                            <path d="M4.98 3.5C4.98 4.881 3.87 6 2.5 6S.02 4.881.02 3.5C.02 2.12 1.13 1 2.5 1s2.48 1.12 2.48 2.5zM5 8H0v16h5V8zm7.982 0H8.014v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0V24H24V13.869c0-7.88-8.922-7.593-11.018-3.714V8z"/>
                        </svg>
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
